<template>

  <v-card v-else elevation="5" style="padding-top: 8px; padding-bottom: 8px">
      <ul style="height: 200px; overflow-y: auto;">
        <li
            style="padding: 5px;"
            v-for="(item, index) in items"
            :class="{'is-selected': index === selectedIndex}"
            :key="index" @click="selectItem(index)">
          <user-suggestion v-if="isUser" :user="item"/>
          <file-suggestion v-else :file="item"/>
        </li>
      </ul>
  </v-card>

</template>

<script>
import UserSuggestion from "./UserSuggestion.vue";
import FileSuggestion from "./FileSuggestion.vue";

export default {
  name: "SuggestionsDropdown",
  components: {UserSuggestion, FileSuggestion},
  props: {
    char: {
      type: String,
      required: true,
    },
    nodeType: {
      type: String,
      required: false,
    },
    nodeProps: {
      type: Object,
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
    command: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    };
  },
  computed: {
    isReference() {
      return this.nodeType === 'reference';
    },

    isUser() {
      return this.isReference && this.nodeProps.referenceType === 'user';
    },

    isFile() {
      return this.isReference && this.nodeProps.referenceType === 'file';
    },
  },

  watch: {
    items() {
      this.selectedIndex = 0;
    },
  },

  methods: {

    getText(item) {
      console.log(item)
      switch (this.nodeType === 'reference' && this.nodeProps.referenceType) {
        case 'user':
          return `${this.char}${item.username}`;
        case 'file':
          return `${this.char}${item.name}`;
        default:
          return '';
      }
    },

    getProps() {
      return this.nodeProps;
    },

    onKeyDown({event}) {
      if (event.key === 'ArrowUp') {
        this.upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        this.downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        this.enterHandler();
        return true;
      }

      return false;
    },

    upHandler() {
      this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length;
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
    },

    enterHandler() {
      this.selectItem(this.selectedIndex);
    },

    selectItem(index) {
      const item = this.items[index];
      if (item) {
        this.command({
          text: this.getText(item),
          href: `#`,
          dataId: item.id,
          ...this.getProps(item),
        });
      }
    },
  },

}
</script>
<style scoped>
.is-selected {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
